import { render, staticRenderFns } from "./GModal.vue?vue&type=template&id=f121f37a&"
import script from "./GModal.vue?vue&type=script&lang=js&"
export * from "./GModal.vue?vue&type=script&lang=js&"
import style0 from "./GModal.vue?vue&type=style&index=0&id=f121f37a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports